<template>
  <path
    d="M12 4.00024C7 4.00024 2.73 7.11024 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C17 19.0002 21.27 15.8902 23 11.5002C21.27 7.11024 17 4.00024 12 4.00024ZM12 16.5002C9.24 16.5002 7 14.2602 7 11.5002C7 8.74024 9.24 6.50024 12 6.50024C14.76 6.50024 17 8.74024 17 11.5002C17 14.2602 14.76 16.5002 12 16.5002ZM12 8.50024C10.34 8.50024 9 9.84024 9 11.5002C9 13.1602 10.34 14.5002 12 14.5002C13.66 14.5002 15 13.1602 15 11.5002C15 9.84024 13.66 8.50024 12 8.50024Z"
  />
</template>
